
import { reactive ,readonly} from 'vue';

const state = reactive({
user :'',
group :[],
userRole : ''
})


const methods ={
setUser (user) {
state.user =user;
},
getUser () {
return state.user;
},
setUserRole (userRole) {
    state.userRole =userRole;
    },
    getuserRole () {
    return state.userRole;
    },
setGroup (group) {
    state.group =group;
    },
    getGroup () {
    return state.group;
    },
}


export default {
state : readonly(state),
methods
}

